import { toJcamps } from './toJcamps.js';
export function toJcamp(analysis, options = {}) {
    return toJcamps(analysis, options).join('\n');
}
//# sourceMappingURL=toJcamp.js.map